// src/components/ModalGanhos.js
import React from "react";

export default function ModalGanhos({ dados, onFechar }) {
  if (!dados) return null;
  const iconePag = dados.metodo === "pix" ? "📱" : ["maquininha", "cartao_zuno"].includes(dados.metodo) ? "💳" : "💵";
  const labelPag = dados.metodo === "pix" ? "Pix" : dados.metodo === "maquininha" ? "Cartão na maquininha" : dados.metodo === "cartao_zuno" ? "Cartão" : "Dinheiro";
  const total = (dados.valorBruto || 0) + (dados.bonusExtra || 0);

  return (
    <div style={{
      position: "fixed", inset: 0, zIndex: 99990,
      background: "rgba(0,0,0,0.8)",
      display: "flex", alignItems: "flex-end",
      fontFamily: "'Segoe UI', system-ui, sans-serif",
    }}>
      <style>{`@keyframes slideUp{from{opacity:0;transform:translateY(100%)}to{opacity:1;transform:translateY(0)}}`}</style>
      <div style={{
        width: "100%", maxWidth: 480, margin: "0 auto",
        background: "#0d1527",
        borderRadius: "24px 24px 0 0",
        padding: "28px 24px 44px",
        border: "1px solid rgba(255,255,255,0.07)",
        borderBottom: "none",
        animation: "slideUp 0.35s ease",
      }}>
        <div style={{ width: 36, height: 4, background: "rgba(255,255,255,0.15)", borderRadius: 2, margin: "0 auto 24px" }} />

        <div style={{ textAlign: "center", marginBottom: 24 }}>
          <div style={{ fontSize: 48, marginBottom: 8 }}>🎉</div>
          <p style={{ color: "#22c55e", fontWeight: 800, fontSize: 20, margin: "0 0 4px" }}>
            Corrida concluída!
          </p>
          <p style={{ color: "rgba(255,255,255,0.35)", fontSize: 13, margin: 0 }}>
            {dados.destino} {dados.distancia ? `• ${Number(dados.distancia).toFixed(1)} km` : ""}
          </p>
        </div>

        {/* Ganho principal */}
        <div style={{
          background: "rgba(34,197,94,0.07)",
          border: "1px solid rgba(34,197,94,0.18)",
          borderRadius: 16,
          padding: "20px",
          textAlign: "center",
          marginBottom: 14,
        }}>
          <p style={{ color: "rgba(255,255,255,0.35)", fontSize: 11, letterSpacing: 1, margin: "0 0 6px", textTransform: "uppercase" }}>
            Você ganhou
          </p>
          <p style={{ color: "#22c55e", fontSize: 42, fontWeight: 800, margin: 0, letterSpacing: -2 }}>
            R$ {Number(total).toFixed(2)}
          </p>
          {dados.bonusExtra > 0 && (
            <p style={{ color: "#f59e0b", fontSize: 12, margin: "6px 0 0", fontWeight: 700 }}>
              🏆 inclui bônus de R$ {Number(dados.bonusExtra).toFixed(2)}
            </p>
          )}
        </div>

        {/* Detalhes */}
        <div style={{
          background: "rgba(255,255,255,0.03)",
          borderRadius: 14,
          padding: "14px 16px",
          marginBottom: 22,
          display: "flex", justifyContent: "space-around",
        }}>
          <div style={{ textAlign: "center" }}>
            <p style={{ color: "rgba(255,255,255,0.3)", fontSize: 10, letterSpacing: 0.8, margin: "0 0 5px", textTransform: "uppercase" }}>Corrida</p>
            <p style={{ color: "#fff", fontSize: 15, fontWeight: 700, margin: 0 }}>R$ {Number(dados.valorBruto || 0).toFixed(2)}</p>
          </div>
          <div style={{ width: 1, background: "rgba(255,255,255,0.07)" }} />
          <div style={{ textAlign: "center" }}>
            <p style={{ color: "rgba(255,255,255,0.3)", fontSize: 10, letterSpacing: 0.8, margin: "0 0 5px", textTransform: "uppercase" }}>Pagamento</p>
            <p style={{ color: "#fff", fontSize: 15, fontWeight: 700, margin: 0 }}>{iconePag} {labelPag}</p>
          </div>
          <div style={{ width: 1, background: "rgba(255,255,255,0.07)" }} />
          <div style={{ textAlign: "center" }}>
            <p style={{ color: "rgba(255,255,255,0.3)", fontSize: 10, letterSpacing: 0.8, margin: "0 0 5px", textTransform: "uppercase" }}>Passageiro</p>
            <p style={{ color: "#fff", fontSize: 14, fontWeight: 600, margin: 0 }}>
              {(dados.passageiroNome || "—").split(" ")[0]}
            </p>
          </div>
        </div>

        <button
          onClick={onFechar}
          style={{
            width: "100%", padding: "15px",
            borderRadius: 14, border: "none",
            background: "linear-gradient(135deg,#7c3aed,#a855f7)",
            color: "#fff", fontSize: 15, fontWeight: 800,
            cursor: "pointer", fontFamily: "inherit",
            boxShadow: "0 4px 20px rgba(124,58,237,0.4)",
          }}
        >
          Avaliar passageiro ⭐
        </button>
      </div>
    </div>
  );
}
